import { Pushbutton } from '@stratumn/atomic';

import graphql from 'babel-plugin-relay/macro';
import compose from 'lodash.flowright';
import PropType from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import injectSheet from 'react-jss';
import { createFragmentContainer } from 'react-relay';
import { withGqlClient, withUser } from 'wrappers';

import AddTeamBotsModal from '../../addTeamBotsModal';
import AddTeamMembersModal from '../../addTeamMembersModal';
import InviteCollaboratorsModal from '../inviteCollaboratorsModal';
import styles from './teamHeader.style';

const INITIAL_STATE = {
  showModal: {
    collaborators: false,
    members: false
  }
};

export class TeamHeader extends React.Component {
  static propTypes = {
    team: PropType.object.isRequired,
    classes: PropType.object.isRequired
  };

  state = INITIAL_STATE;

  toggleModal = name =>
    this.setState({
      showModal: {
        [name]: !this.state.showModal[name]
      }
    });

  render() {
    const { classes, team } = this.props;
    const { showModal } = this.state;

    return ReactDOM.createPortal(
      <>
        {showModal.members && (
          <AddTeamMembersModal
            onClose={() => this.toggleModal('members')}
            teamAccountRowId={team.account.rowId}
            teamId={team.id}
          />
        )}
        {showModal.collaborators && (
          <InviteCollaboratorsModal
            onClose={() => this.toggleModal('collaborators')}
            teamAccountRowId={team.account.rowId}
            teamId={team.id}
          />
        )}
        {showModal.bots && (
          <AddTeamBotsModal
            onClose={() => this.toggleModal('bots')}
            teamAccountRowId={team.account.rowId}
            teamId={team.id}
          />
        )}

        {team.canUpdate && (
          <div className={classes.actions}>
            <div className={classes.action}>
              <Pushbutton
                data-testid="invite-collaborators-button"
                onClick={() => this.toggleModal('collaborators')}
                secondary
              >
                Invite Collaborators
              </Pushbutton>
            </div>
            <div className={classes.action}>
              <Pushbutton
                data-testid="add-members-button"
                onClick={() => this.toggleModal('members')}
                secondary
              >
                Add Members
              </Pushbutton>
            </div>
            <Pushbutton
              data-testid="add-bots-button"
              onClick={() => this.toggleModal('bots')}
              secondary
            >
              Add Bots
            </Pushbutton>
          </div>
        )}
      </>,
      document.getElementById('btn-invite-collaborators')
    );
  }
}

export default createFragmentContainer(
  compose(withUser, withGqlClient, injectSheet(styles))(TeamHeader),
  {
    team: graphql`
      fragment teamHeader_team on Team {
        id
        name
        canUpdate
        account {
          rowId
        }
      }
    `
  }
);
